//修改日志
import {httpGet, httpPost} from "@/request";

//获取修改日志的初始值
function getInitAppInfo(data) {
    if(data) {
        const url = '/api/getStartAppInfo';
        return new Promise((resolve, reject) => {
            httpPost(url, data).then(res => {
                if(res) {
                    resolve(res);
                } else {
                    reject('获取数据失败');
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
};

//新增或修改资料申请记录
function addLog(data) {
    if(data) {
        const url = '/api/addAppLog';
        return new Promise((resolve, reject) => {
            httpPost(url, data).then(res => {
                if(res && res.id) {
                    resolve(res);
                } else {
                    reject('操作失败');
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
    return new Promise.reject('请求错误');
}

//获取当前老师的所有修改记录
function getTeachAllModifyLogs(data) {
    if(data) {
        const url = '/api/getTeachAllModifyLogs';
        return new Promise((resolve, reject) => {
            httpPost(url, data).then(res => {
                if(res && res.data) {
                    resolve(res.data);
                } else {
                    reject('获取数据失败');
                };
            }).catch(err => {
                reject(err);
            });
        });
    }
}

export {
    getInitAppInfo,
    addLog,
    getTeachAllModifyLogs
}